import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {GetFaqsForUrlSearchRequest} from '../Request/GetFaqsForUrlSearchRequest.js'

class GetFaqsForUrlSearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetFaqsForUrlSearchUseCase({config, repository: HttpSearchRepository.create({config})})
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetFaqsForUrlSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({targetUrl}) {
    const getFaqsRequest = GetFaqsForUrlSearchRequest.create({
      config: this.#config,
      targetUrl
    })

    const [error, faqsResponse] = await this.#repository.getFaqsForUrlSearch({getFaqsRequest})

    if (error) return Promise.reject(error)

    return faqsResponse
  }
}

export const factory = GetFaqsForUrlSearchUseCase.create
